import { createContext, useContext, type PropsWithChildren } from "react";
import type { CommerceOrderApi } from "../data/CommerceOrderApi";

const Context = createContext<CommerceOrderApi | null>(null);

export function CommerceOrderProvider({ api, children }: PropsWithChildren<{ api: CommerceOrderApi }>) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useCommerceOrderApi() {
  const value = useContext(Context);
  if (!value) throw new Error("useCommerceOrderApi must be used within CommerceOrderProvider");
  return value;
}
